// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 779 ? "62b87628" : chunkId) + "." + {"249":"c3790c1462d5876f","698":"dfb18316771a768b","779":"e346d489eeb4c0b0"}[chunkId] + ".js";
};